import React, { useState } from 'react'
import BookAppointment from './BookAppointment';
import IVFExperts from './IVFExperts';
import OurHospitals from './OurHospitals';
import ContatUS from './ContactUs';
import FAQs from './FAQs';
import you from '../../assets/images/boy.png'

import Lastmenu from './Lastmenu';

const Mainmenu = ({ name: initialName, mobile: initialMobile}) => {
  const [name, setName] = useState(initialName || "");
  const [mobile, setMobile] = useState(initialMobile || "");
  
  const [time1,setTime1] = React.useState(new Date());
  
  const [showMenu, setShowMenu] = useState(true);

  const [activeFrames, setActiveFrames] = useState([{ id: 1, component: "Mainmenu" }]); // Root frame

  const handleShowFrame = (parentId, frameName) => {
    setShowMenu(false);
    setTime1(new Date());
    setActiveFrames((prevFrames) => [
      ...prevFrames,
      { id: prevFrames.length + 1, parentId, component: frameName },
    ]);
  };
  
  const renderFrame = (frame) => {
    let FrameComponent = null;
    switch (frame.component) {
      case "BookAppointment":
  return (
    <div key={frame.id}>
      <div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time1?.toLocaleTimeString()}
      </div>
      <div className="you-message">
        <div className="frame2">BookAppointment</div>
      </div>
      <BookAppointment
        doctorId={null} // or pass if available
        name={name}
        mobile={mobile}
        handleShowFrame={handleShowFrame}
        parentId={frame.id}
      />
    </div>
  );
      case "IVFExperts":
        return (
          <div key={frame.id}>
            <div className="you-time">
              <img src={you} alt="boy" className="boy" />
              You {time1?.toLocaleTimeString()}
            </div>
            <div className="you-message">
              <div className="frame2">BookAppointment</div>
            </div>
            <IVFExperts
              doctorId={null} // or pass if available
              name={name}
              mobile={mobile}
              handleShowFrame={handleShowFrame}
              parentId={frame.id}
            />
          </div>
        );
      case "OurHospitals":
        FrameComponent = OurHospitals;
        break;
      case "InternationalPatients":
        return(
          <>
          <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className='you-message'>
            <div className='frame2'>International Patients</div>
          </div>
            <Lastmenu />
          </>
        );
        
      case "SuccessStories":
        return(
          <>
             <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className='you-message'>
            <div className='frame2'>Success Stories</div>
          </div>
            <Lastmenu />
          </>
        );
        
      case "ReferaFriend":
        return(
          <>
             <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className='you-message'>
            <div className='frame2'>Refer a Friend</div>
          </div>
            <Lastmenu />
          </>
        );
          
      case "ContactUs":
            FrameComponent = ContatUS;
            break;
      case "FAQ's":
        FrameComponent = FAQs;
        break;
      default:
        return null;
    }
  
    return (
      <div key={frame.id}>
        <div className="you-time">
          <img src={you} alt="boy" className="boy" />
          You {time1?.toLocaleTimeString()}
        </div>
        <div className="you-message">
          <div className="frame2">{frame.component}</div>
        </div>
        <FrameComponent handleShowFrame={handleShowFrame}  parentId={frame.id} />
      </div>
    );
  };
  
  return (
    <div style={{ marginBottom: '10px' }}>
      
        <div className='frame1 animated-frame'>
            👋 Hi there! How can I assist you today?<br />
            Choose an option below to get started.
        </div>

        {
            showMenu &&
            <div className='menu-btns animated-frame'>
                <button className='menu-btn' onClick={() => handleShowFrame(2, "BookAppointment")}>Book an Appointment</button>
                <button className='menu-btn' onClick={() => handleShowFrame(3, "IVFExperts")}>Our IVF Experts</button><br></br>
                <button className='menu-btn' onClick={() => handleShowFrame(4, "OurHospitals")}>Our Hospitals</button>
                <a href="https://hegdefertility.com/international/" target="_blank" rel="noopener noreferrer"><button className='menu-btn' onClick={() => handleShowFrame(5, "InternationalPatients")}>International Patients</button></a><br></br>
                <a href="https://hegdefertility.com/feedback-testimonials/" target="_blank" rel="noopener noreferrer"><button className='menu-btn' onClick={() => handleShowFrame(6, "SuccessStories")}>Success Stories</button></a>
                <button className='menu-btn' onClick={() => handleShowFrame(7, "ReferaFriend")}>Refer a Friend</button><br></br>
                <button className='menu-btn' onClick={() => handleShowFrame(8, "ContactUs")}>Contact Us</button>
                <button className='menu-btn' onClick={() => handleShowFrame(9, "FAQ's")}>FAQ's</button>
            </div>
        }
        {activeFrames.slice(1).map(renderFrame)}
    </div>
    
  )
}

export default Mainmenu